// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18CM6","top":"styles_top__1SeYV","left":"styles_left__1Ptm7","description":"styles_description__3s00y"};